import { CDatePicker } from './CDatePicker.js';

const CDatePickerPlugin = {
    install: (app) => {
        app.component(CDatePicker.name, CDatePicker);
    },
};

export { CDatePicker, CDatePickerPlugin };
//# sourceMappingURL=index.js.map
